/** Prefer non-empty form value; otherwise fall back to content/import value. Never cross-map fields. */
export function pickFormOrContentStr(
  formVal: string | null | undefined,
  contentVal: string | null | undefined,
): string {
  const formTrimmed = (formVal ?? '').trim();
  if (formTrimmed) return formVal as string;
  return (contentVal ?? formVal ?? '') as string;
}

export function pickFormOrContentNullable(
  formVal: string | null | undefined,
  contentVal: string | null | undefined,
): string | null {
  const formTrimmed = (formVal ?? '').trim();
  if (formTrimmed) return formVal ?? null;
  return contentVal ?? formVal ?? null;
}

/** Address line 1 must not duplicate the auditor name (common import/sync contamination). */
export function sanitizeFormerAuditorAddress(
  formerAuditor: string | null | undefined,
  addressOfFormerAuditor: string | null | undefined,
): string {
  const name = (formerAuditor ?? '').trim();
  const address = (addressOfFormerAuditor ?? '').trim();
  if (!address) return '';
  if (name && address === name) return '';
  return addressOfFormerAuditor ?? '';
}

export function buildFormerAuditorInitialFields(
  form: {
    formerAuditor?: string | null;
    addressOfFormerAuditor?: string | null;
    professionalClearance?: string | null;
  } | null | undefined,
  content: {
    formerAuditor?: string | null;
    addressOfFormerAuditor?: string | null;
    professionalClearance?: string | null;
  } | null | undefined,
) {
  const formerAuditor = pickFormOrContentStr(form?.formerAuditor, content?.formerAuditor);
  const rawAddress = pickFormOrContentStr(form?.addressOfFormerAuditor, content?.addressOfFormerAuditor);
  return {
    formerAuditor,
    addressOfFormerAuditor: sanitizeFormerAuditorAddress(formerAuditor, rawAddress),
    professionalClearance: pickFormOrContentNullable(form?.professionalClearance, content?.professionalClearance),
  };
}
